/**
 * 判断：是管理员们
 * @param {*} user
 * @returns 
 */
export const isAdmins = (user) => {
    return '1' == user?.isPlatformAdm || '2' == user?.isPlatformAdm;
}

/**
 * 判断：是超级管理员
 * @param {*} user
 * @returns 
 */
export const isSysAdmin = (user) => {
    return '2' == user?.isPlatformAdm;
}